export default __webpack_public_path__ + "static/media/507.7110b3f8.png";